<template>
  <v-chip v-bind="$attrs" :style="chipStyle" >
    {{label}}
  </v-chip>
</template>

<script>
import colorMixin from "@/components/mixins/ColorMixin";

export const NLQ_STATUS = {
  FAILED  : "failed",
  REJECTED  : "rejected",
  REVIEW  : "review",
  VALIDATED : "validated",
}

export default {
  name: "NlQueryStatusChip",
  mixins: [colorMixin],
  props: {
    value: { type:String, default: NLQ_STATUS.REVIEW }, // 'review' | 'failed' | 'rejected' | 'validated'
    noColor: {type: Boolean, default: false },
  },
  inheritAttrs: false,
  computed: {
    config() {
      return this.nlqStatusColors(this.value) || this.nlqStatusColors(NLQ_STATUS.REVIEW)
    },
    label() {
      return this.config.label
    },
    chipStyle() {
      return {
        backgroundColor: this.noColor ? "#ECEFF1" : this.config.backgroundHex,
        color: this.noColor ? "#90A4AE" : this.config.colorHex
      }
    }
  },
}
</script>